import React, {useState, useEffect} from 'react';
import MathJax from "../react-mathjax-preview";
import TextEditor from '../TextEditor';
import MQTCheckBox, { useCheckBoxStateHandler } from './MQTSelectBox';


const objectsToArray = (objectArray) => {
    return objectArray.sort((a, b) => {
        if(a.displayOrder !== undefined && a.displayOrder !== null 
            && b.displayOrder !== undefined && b.displayOrder !== null) {
                return parseInt(a.displayOrder) - parseInt(b.displayOrder)
        } else {
            return -1;
        }
    });
}

const  MQTDisplayOption2 = (props) =>{

    const [selectedAnswers,onClick] = useCheckBoxStateHandler(props.mqt_answer_type); //https://reactjs.org/docs/hooks-overview.html
    const {mqt_answer_type,readOnly,mqt_questions,disableHTMLConversion,mqt_answers,mqt_hide_question} =  props;

    const [questions, setQuestions] = useState([]);
    const [answers, setAnswers] = useState([]);

    useEffect(()=>{
        if(mqt_questions){
            setQuestions(shuffle(Object.values(mqt_questions), props.random_order))
        }
    },[props])

    useEffect(()=>{
        if(mqt_answers){
            setAnswers(shuffle(Object.values(mqt_answers), props.random_answer_order))
        }
    },[props])

    const shuffle=(arra1, random_order) =>{
        if(arra1 && random_order) {
          var ctr = arra1.length, temp, index;
          // While there are elements in the array
              while (ctr > 0) {
          // Pick a random index
                  index = Math.floor(Math.random() * ctr);
          // Decrease ctr by 1
                  ctr--;
          // And swap the last element with it
                  temp = arra1[ctr];
                  arra1[ctr] = arra1[index];
                  arra1[index] = temp;
              }
        } else {
            arra1 = objectsToArray(arra1);
        }

        return arra1;
    }

    return <div className='sf-mqt-container'>
         <div className='mt-2 mb-4' >Select your answers:</div>
            <div className='sf-mqt-table'>
                <table size="small" style={{borderCollapse:"collapse"}}>
                    <thead align="center">
                        <tr>
                        {mqt_hide_question ? <td align='center' style={{display:"none"}}></td> : <td></td>} 
                            {
                                answers.map(answer => {
                                    let content;
                                    if(disableHTMLConversion){
                                        content   =   React.createElement(MathJax,{"math":answer.value});
                                    }else{
                                        content   =   React.createElement(MathJax,{"math":TextEditor.getHTMLStringFromEditorState(answer.value)});
                                    }
                                
                                    return <td sx={{border:'1px solid #EEF1F4'}} align="center">{content}</td>
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            questions.map(question=>{
                                let content;
                                if(disableHTMLConversion){
                                    content   =   React.createElement(MathJax,{"math":question.value});
                                }else{
                                    content   =   React.createElement(MathJax,{"math":TextEditor.getHTMLStringFromEditorState(question.value)});
                                }
                                let radioButtons = [];
                                let selectedAnswerArray;
                                if(selectedAnswers)
                                    selectedAnswerArray = selectedAnswers[question.id];

                                let answers = Object.values(mqt_answers);
                                for (let index = 0; index < answers.length; index++) {
                                    let checked = false;
                                    if(selectedAnswerArray && selectedAnswerArray.length>0){
                                        checked = selectedAnswerArray.includes(answers[index].id);
                                        console.log('checked'+checked);
                                        
                                    }

                                    radioButtons.push(<td align='center'  sx={{border:'1px solid #EEF1F4'}} > <MQTCheckBox onClick={(isChecked)=>{onClick(question.id,answers[index].id,isChecked)}} type={mqt_answer_type} checked={checked}   readyOnly={readOnly} value={index+1}/></td>);
                                
                                }
                                
                                return <tr>
                                    {mqt_hide_question ? <td align='center'  style={{display:"none"}}>{content}</td>: <td align='center' sx={{border:'1px solid #EEF1F4'}}> {content}</td>}
                                            
                                            {radioButtons}
                                        </tr>
                            })
                        }
                    </tbody>
                </table>    
              </div>
    
        </div>
    

    
}

export default MQTDisplayOption2;